/**
 * 지도/상담 조회
 */
import React, { Component } from 'react';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, openAlert, openConfirm } from '../../common/common';
import { Navbar, ListGroup, Button, Badge, Row, Col, ButtonToolbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import $ from 'jquery';
import loader from '../../imgs/ajax-loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faAngleRight, faAssistiveListeningSystems, faPhone, faPen, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { udfSetHakgwaList, udfSetStdtInfo } from '../../common/usr/stdtList';
import { Link } from 'react-router-dom';
import { dropByCacheKey } from 'react-router-cache-route'

const recordCountPerPage = 10;	// 한번에 불러 올 레코드 개수
let firstIndex = 0;	// 불러 올 시작 레코드
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;
let isLogging = false;

let that = this;

class StdtCnslHistoryCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      STD_CD: props.match.params.stdCd,
      cnslList: [],
      stdtInfo: {},
      teacherInfo: {},
      usrInfo: null,
    }
  }

  componentDidMount = () => {
    if (isMore && !isRunning && !isLogging) {
      isLogging = true;
      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        if (data !== null && data.userSe === 'STDT') {
          this.props.history.push('/stdt/ruleList');
        } else if (data !== null && data.userSe === 'USR') {
          isLogging = false;
          this.setState({ usrInfo: data });
          this.udfSelectStdtCnslHistory('Y');
        } else {
          this.props.history.push('/');
        }
      });
    }

    dropByCacheKey('stdtRuleHistoryCachce');

    if (this.state.cnslList.length === 0) {
      isMore = true;
      isRunning = false;
      firstIndex = 0;
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0 || $('.modal-backdrop.show').length > 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && isMore) {
      this.udfSelectStdtCnslHistory('N');
    }
  }

  udfSelectStdtCnslHistory = (clearYn) => {
    if (!this.state.usrInfo || isLogging) return;

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
    }

    that = this;
    if (isMore && !isRunning) {
      udfInlineLoading();
      isRunning = true;

      $.ajax({
        url: url + '/sli/cnsl/selectCnslHistory.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          searchKeyword: this.state.STD_CD,
          firstIndex: firstIndex,
          recordCountPerPage: recordCountPerPage,
        },
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            let cnslList = [];
            let stdtInfo = {};
            let teacherInfo = {};
            let auth_yn = '';

            if (data.user.JG_U_YN === 'Y') {
              if (data.user.JG_I_YN === 'Y') {
                auth_yn += '지도상담 추가/수정, ';
              } else auth_yn += '지도상담 수정, ';
            } else {
              if (data.user.JG_I_YN === 'Y') auth_yn += '지도상담 추가, ';
            }

            teacherInfo = {
              ESNTL_GU: data.user.ESNTL_GU,
              JG_I_YN: data.user.JG_I_YN,
              JG_U_YN: data.user.JG_U_YN,
              HAKGWA: data.user.HAKGWA,
              GRADE: data.user.GRADE,
              BAN: data.user.BAN,
              name: data.user.name,
              uniqId: data.user.uniqId,
              auth_yn: auth_yn
            };

            stdtInfo = {
              BAN: data.stdtList[0].BAN,
              BUN: data.stdtList[0].BUN,
              GRADE: data.stdtList[0].GRADE,
              HAKGWA: data.stdtList[0].HAKGWA === undefined ? '' : data.stdtList[0].HAKGWA,
              STD_CD: data.stdtList[0].STD_CD,
              STD_NM: data.stdtList[0].STD_NM,
              HP_STD: data.stdtList[0].HP_STD === undefined ? '' : data.stdtList[0].HP_STD,
              HP_PRT: data.stdtList[0].HP_PRT === undefined ? '' : data.stdtList[0].HP_PRT,
              HP_PRT2: data.stdtList[0].HP_PRT2 === undefined ? '' : data.stdtList[0].HP_PRT2,
              STD_STATUS: data.stdtList[0].STD_STATUS,
              OTHER_CD: data.stdtList[0].OTHER_CD === undefined ? '' : data.stdtList[0].OTHER_CD,
              LAST_UPDATE: data.stdtList[0].LAST_UPDATE
            };

            if (data.resultList !== undefined && data.resultList !== null) {
              var idx = firstIndex;
              $.each(data.resultList, function (i, val) {
                idx++;

                cnslList.push({
                  STD_CD: val.STD_CD,
                  JG_DATE: val.JG_DATE,
                  JG_SEQ: val.JG_SEQ,
                  JG_TIME: val.JG_TIME,
                  CNSL_PLACE: val.CNSL_PLACE,
                  CNSL_DESC: val.CNSL_DESC,
                  ESNTL_ID: val.ESNTL_ID,
                  ESNTL_NM: val.ESNTL_NM,
                  JG_CD: val.JG_CD,
                  JG_DESC: val.JG_DESC,
                  JG_SDATE: val.JG_SDATE,
                  JG_EDATE: val.JG_EDATE,
                  JG_POINT: val.JG_POINT,
                  JG_APLY_YN: val.JG_APLY_YN,
                  MSG_YN: val.MSG_YN,
                  MSG_CNT: val.MSG_CNT,
                  DEL_YN: val.DEL_YN,
                  LAST_UPDATE: val.LAST_UPDATE,
                });
              });

              if (idx - firstIndex !== recordCountPerPage) isMore = false;
              firstIndex += recordCountPerPage;

              if (clearYn === 'N') cnslList = that.state.cnslList.concat(cnslList);

              // 학과 목록
              let hakgwaList = [];
              udfSetHakgwaList(hakgwaList);
              $.each(data.hakgwaList, function (i, v) {
                hakgwaList.push(v.HAKGWA);
              });
              udfSetHakgwaList(hakgwaList);

              udfSetStdtInfo(stdtInfo);

              that.setState({
                isLoggedIn: true,
                stdtInfo: stdtInfo,
                cnslList: cnslList,
                teacherInfo: teacherInfo,
                alertShow: false,
                stdtInfoAlertShow: false,
                I_HAKGWA: stdtInfo.HAKGWA,
                I_GRADE: stdtInfo.GRADE,
                I_BAN: stdtInfo.BAN,
                I_BUN: stdtInfo.BUN,
                I_STD_NM: stdtInfo.STD_NM,
                I_HP_STD: stdtInfo.HP_STD,
                I_HP_PRT: stdtInfo.HP_PRT,
                I_HP_PRT2: stdtInfo.HP_PRT2,
              });
            }
          }
          isRunning = false;
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          that.componentDidMount();
          udfNoneLoading();
        }
      });
    }
  }

  fn_updateCnslAplyYnAlert = (data, aplyYn) => {
    if (this.state.teacherInfo.ESNTL_GU === 'T' && this.state.teacherInfo.JG_I_YN === 'N' && this.state.teacherInfo.JG_U_YN === 'N') {
      openAlert(this, '수정 권한이 없습니다. 학교관리자에게 문의하여 주시기 바랍니다.');
      return;
    }

    if (data.JG_EDATE === '') {
      openAlert(this, '지도 종료일이 없는 지도/상담 건은 차감 적용을 할 수 없습니다.');
      return;
    }

    let msg = '지도 후 차감 적용 하시겠습니까?\n\n적용일자는 지도종료일로 자동 입력됩니다.';
    if (aplyYn === 'N') msg = '취소하시겠습니까?';

    that = this;
    openConfirm(this, msg, function () { that.fn_updateCnslAplyYn(data, aplyYn); });
  }

  fn_updateCnslAplyYn = (data, aplyYn) => {
    const sendData = {
      isMobile: 'Y',
      JG_DATE: data.JG_DATE,
      JG_SEQ: data.JG_SEQ,
      ESNTL_ID: data.ESNTL_ID,
      JG_EDATE: data.JG_EDATE,
      JG_POINT: data.JG_POINT,
      JG_APLY_YN: aplyYn,
      STD_CD: data.STD_CD,
    }

    that = this;
    let gu = '적용';
    if (aplyYn === 'N') gu = '취소';

    udfInlineLoading();

    $.ajax({
      url: url + '/sli/cnsl/updateCnslAplyYn.do',
      type: 'GET',
      dataType: 'jsonp',
      data: sendData,
      success: function (data) {
        udfNoneLoading();

        if (!data.success)
          that.componentDidMount();
        else {
          if (data.result === 1) {
            that.udfSelectStdtCnslHistory('Y');
          } else {
            openAlert(that, '차감 ' + gu + ' 도중 오류가 발생했습니다.');
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  fn_updateCnslDelYnAlert = (data, delYn) => {
    if (this.state.teacherInfo.ESNTL_GU === 'T' && this.state.teacherInfo.JG_U_YN === 'N') {
      openAlert(this, '수정 및 삭제 권한이 없습니다. 학교관리자에게 문의하여 주시기 바랍니다.');
      return;
    }

    let msg = '삭제하시겠습니까?';
    if (delYn === 'N') msg = '복구하시겠습니까?\n\n해당 건 복구로 인한 중복 발생건이 존재할 수 있습니다.';

    that = this;
    openConfirm(this, msg, function () { that.fn_updateCnslDelYn(data, delYn) });
  }

  fn_updateCnslDelYn = (data, delYn) => {
    const sendData = {
      isMobile: 'Y',
      STD_CD: data.STD_CD,
      JG_DATE: data.JG_DATE,
      JG_SEQ: data.JG_SEQ,
      JG_POINT: 0,
      DEL_YN: delYn
    }

    that = this;
    let gu = '삭제';
    if (delYn === 'N') gu = '복구';

    $.ajax({
      url: url + '/sli/cnsl/updateCnslDelYn.do',
      type: 'GET',
      dataType: 'jsonp',
      data: sendData,
      success: function (data) {
        udfNoneLoading();

        if (!data.success)
          that.componentDidMount();
        else {
          if (data.result === 1) {
            that.udfSelectStdtCnslHistory('Y');
          } else {
            openAlert(that, gu + ' 도중 오류가 발생했습니다.');
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  render() {
    const setCnslList = this.state.cnslList.map((data, idx) => (
      <div className='list-group-item' key={idx} style={{ border: 'none' }}>
        <div className='row ruleRow mt-4'>
          <div className='col-auto' style={{ padding: '0' }}>
            <span className='green-point'>
              <FontAwesomeIcon icon={faAssistiveListeningSystems} />
            </span>
          </div>
          <div className='col' style={{ paddingRight: '0' }}>
            <div className='font-weight-bold'>
              {data.DEL_YN === 'Y'
                ? <span style={{ color: "red", textDecoration: "line-through" }}> {data.JG_DATE} {data.JG_TIME} 삭제됨 </span>
                : data.JG_DATE + ' ' + data.JG_TIME}
            </div>
            <dl>
              <dt className='font-weight-normal'><FontAwesomeIcon icon={faAngleRight} /> 상담내용</dt>
              <dd className='pl-4'>{data.CNSL_DESC}</dd>
              <dt className='font-weight-normal'><FontAwesomeIcon icon={faAngleRight} /> 지도내용</dt>
              <dd className='pl-4'>{data.JG_DESC}</dd>
              <dt className='font-weight-normal'><FontAwesomeIcon icon={faAngleRight} /> 지도기간</dt>
              <dd className='pl-4'>{data.JG_SDATE} {data.JG_EDATE !== '' ? '~ ' + data.JG_EDATE : ''}</dd>
              <dt className='font-weight-normal'><FontAwesomeIcon icon={faAngleRight} /> 지도차감점수</dt>
              <dd className='pl-4'><span className='point font-weight-bold' style={{ float: 'unset', fontSize: '1.1rem' }}>{data.JG_POINT} 점</span></dd>
            </dl>
            <div>
              <span style={{ float: 'left' }}>교사: {data.ESNTL_NM}</span>
            </div>
          </div>
        </div>
        <Row>
          {
            data.JG_APLY_YN === 'N' ?
              <Col><Button variant='outline-info' className='p-2' style={{ width: '100%' }} onClick={() => this.fn_updateCnslAplyYnAlert(data, 'Y')}>차감적용</Button></Col> :
              <Col><Button variant='outline-primary' className='p-2' style={{ width: '100%' }} onClick={() => this.fn_updateCnslAplyYnAlert(data, 'N')}>차감적용 취소</Button></Col>
          }
          {
            this.state.teacherInfo.ESNTL_GU !== 'T' || (this.state.teacherInfo.ESNTL_GU === 'T' && this.state.teacherInfo.JG_U_YN === 'Y') ?
              data.DEL_YN === 'Y' ?
                <Col><Button variant='outline-success' className='p-2' style={{ width: '100%' }} onClick={() => this.fn_updateCnslDelYnAlert(data, 'N')}>복구</Button></Col> :
                <Col><Button variant='outline-danger' className='p-2' style={{ width: '100%' }} onClick={() => this.fn_updateCnslDelYnAlert(data, 'Y')}>삭제</Button></Col>
              : ''
          }
        </Row>
      </div>
    ));

    return (
      <>
        {/* to the top */}
        <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>

        <div className='wrap-loading'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className='goBackBtn'><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className='btn-home' /></div></div>
          <div>
            {this.state.stdtInfo.HAKGWA}{this.state.stdtInfo.HAKGWA !== undefined ? ' ' + this.state.stdtInfo.GRADE : this.state.stdtInfo.GRADE}-{this.state.stdtInfo.BAN}-{this.state.stdtInfo.BUN} {this.state.stdtInfo.STD_NM}
          </div>
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <div className='container-fluid' style={{ padding: '0', marginBottom: '4rem' }}>
          <ListGroup variant='flush' style={{ marginTop: '55px' }}>
            <ListGroup.Item>
              <Row>
                <Col className='text-nowrap'>
                  {
                    this.state.stdtInfo.HP_STD !== '' ?
                      <a href={`tel:${this.state.stdtInfo.HP_STD}`} className='mr-2' ><FontAwesomeIcon icon={faPhone} /> 학생</a>
                      : ''
                  }
                </Col>
                <Col className='text-nowrap'>
                  {
                    this.state.stdtInfo.HP_PRT !== '' ?
                      <a href={`tel:${this.state.stdtInfo.HP_PRT}`} className='mr-2' ><FontAwesomeIcon icon={faPhone} /> 학부모1</a>
                      : ''
                  }
                </Col>
                <Col className='text-nowrap'>
                  {
                    this.state.stdtInfo.HP_PRT2 !== '' ?
                      <a href={`tel:${this.state.stdtInfo.HP_PRT2}`} ><FontAwesomeIcon icon={faPhone} /> 학부모2</a>
                      : ''
                  }
                </Col>
                <Col className='col-2 text-center'>
                  {
                    this.state.teacherInfo.ESNTL_GU !== 'T' ||
                      (this.state.teacherInfo.ESNTL_GU === 'T' &&
                        this.state.stdtInfo.HAKGWA === this.state.teacherInfo.HAKGWA &&
                        this.state.stdtInfo.GRADE === this.state.teacherInfo.GRADE &&
                        this.state.stdtInfo.BAN === this.state.teacherInfo.BAN) ?
                      <Link to={`/usr/stdtInfo`}>
                        <Badge
                          variant='success'
                          style={{
                            padding: '10px',
                            fontSize: '100%',
                            float: 'right'
                          }}
                        ><FontAwesomeIcon icon={faPen} /></Badge></Link> : ''
                  }
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item className='no-padding' style={{ borderBottom: 'none', borderTop: 'none' }}>
              <ButtonToolbar>
                <ToggleButtonGroup type='radio' name='options1' defaultValue={['CNSL']} style={{ width: '100%' }} >
                  <ToggleButton variant='light' className='col' value={'RULE'} style={{ borderRadius: '0' }} onClick={() => {
                    this.props.history.push(`/usr/stdtRuleHistory/${this.state.stdtInfo.STD_CD}`)
                  }}>
                    {this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}/{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'}
                  </ToggleButton>
                  <ToggleButton variant='light' className='col' value={'CNSL'} style={{ borderRadius: '0' }}>지도/상담</ToggleButton>
                </ToggleButtonGroup>
              </ButtonToolbar>
            </ListGroup.Item>
            <ListGroup.Item style={{ borderTop: 'none' }}>
              부여된 권한: <span className="text-danger">{this.state.teacherInfo.auth_yn}</span>
              <div className='text-danger'>※ 추가 및 수정은 PC웹 서비스를 이용해 주세요.</div>
            </ListGroup.Item>
            <ListGroup.Item className='stdtInfoTitle font-weight-bold'>지도/상담 현황</ListGroup.Item>
            {setCnslList}
          </ListGroup>
        </div>
      </>
    );
  }
}

export default StdtCnslHistoryCmp;